import React from 'react';
import { FaMapMarkerAlt, FaMapPin } from 'react-icons/fa';
import '../../styles/components/map_interaction/CustomMarker.css';

const CustomMarker = ({ color = 'purple', size = '34px', label = 'Marker', type = 'generic' }) => {
  const MarkerIcon = type === 'suggestion' ? FaMapPin : FaMapMarkerAlt;
  return (
    <div aria-label={label} role="img" className="marker">
      <MarkerIcon color={color} size={size} />
    </div>
  );
};

export default CustomMarker;
